import { Box } from '@mui/material';
import { BreakpointProperties } from '../../../../hooks/useBreakpoint';
import {
  CfDataGridForStoreDataProps,
  CfDataGridProps,
  CfDataGridSheetViewDefinition,
  NavigableElement,
} from '../../CfDataGridProps';
import { getPropertyByBreakpoint } from '../../utility/breakpoint';
import { KeyboardNavigator } from '../../utility/keyboard-navigation';
import { StyledTableContainer } from '../DataGridTableView/CfDataGridTableView.styles';
import { CfDataGridSheetViewBody } from './body/CfDataGridSheetViewBody';

export function CfDataGridMultiTableView<TItem, TAppState>(props: {
  dataGridProps: CfDataGridProps<TItem> | CfDataGridForStoreDataProps<TItem, TAppState>;
  keyboardNavigator: KeyboardNavigator;
  breakpointProperties: BreakpointProperties;
}): JSX.Element {
  if (!props.dataGridProps.sheetView) return <></>;

  const breakpoint = props.breakpointProperties.breakpoint;
  const tableViewDefinition = getPropertyByBreakpoint<CfDataGridSheetViewDefinition<TItem>>(
    props.dataGridProps.sheetView,
    breakpoint
  );

  props.keyboardNavigator.reset();
  const setNavigableElement = (navigableElement: NavigableElement, rowIndex: number, columnIndex: number) =>
    props.keyboardNavigator.registerNavigableElement(navigableElement, { rowIndex, columnIndex });

  return (
    <StyledTableContainer>
      <Box {...tableViewDefinition.tableProps}>
        <CfDataGridSheetViewBody
          dataGridProps={props.dataGridProps}
          tableViewDefinition={tableViewDefinition}
          setNavigableElement={setNavigableElement}
        />
      </Box>
    </StyledTableContainer>
  );
}
